import FetchEntity from './FetchEntity.es6';
const ServicesConsumer = require('../../../../../../reactServiceContext').default;

export default ServicesConsumer('EntityHelpers')(FetchEntity);



// WEBPACK FOOTER //
// ./src/javascripts/app/widgets/structured_text/plugins/shared/FetchEntity/index.es6.js